import React from 'react';

import classNames from 'classnames';

import { RDS_ICON } from '../Icon';

const SystemPaginationArrowRight = React.forwardRef<
  HTMLSpanElement, // The reference type - which element the final ref is attached to.
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...spanProps }, forwardedRef) => {
  // System Icons are size 16 only
  const iconClasses = classNames(RDS_ICON, `${RDS_ICON}-16`, className);

  // Spans are used here for sizing the SVG and to keep in line with the current styles
  // TODO: explore decoupling the svg itself from the outer contents: https://jira.rallyhealth.com/browse/UCRON-1455
  return (
    <span ref={forwardedRef} {...spanProps} className={iconClasses}>
      <span className="h-rds-nav-button-forward-caret">
        <svg
          focusable="false"
          height="16"
          role="presentation"
          viewBox="0 0 16 16"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.002 8l-7.684 7.712a.998.998 0 01-1.413.001 1.001 1.001 0 010-1.415l6.269-6.284-6.27-6.298A1.002 1.002 0 013.905.3a1 1 0 011.32-.083L5.317.3 13.003 8z"
            fillRule="evenodd"
          />
        </svg>
      </span>
    </span>
  );
});

export default SystemPaginationArrowRight;
